import MomentUtils from '@date-io/moment'
import { Grid, TextField } from '@material-ui/core'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import React from 'react'
import { backendDateFormat, fieldDateFormat } from '../../../constants'
import moment from 'moment'
import { regexConstants } from '../../../constants/regEx'

export default function MADetails({ data, type, onFieldChange, error, onFocus }) {
    return (
        <>
            <Grid item sm={type == 'add' ? '4' : '12'}>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                        margin="normal"
                        required
                        id="as_of_date"
                        label={type === 'unlink' ? "Date of Removal" : "Date of Installation"}
                        format={fieldDateFormat}
                        fullWidth
                        disableFuture
                        InputLabelProps={{ shrink: true }}
                        value={data.as_of_date ? data.as_of_date : null}
                        onChange={(e, value) => onFieldChange('as_of_date', e ? moment(e).format(backendDateFormat) : null)}
                        maxDate={moment()}
                        error={error?.as_of_date || false}
                        helperText={error?.as_of_date || ''}
                        inputVariant='outlined'
                    />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item sm={type == 'add' ? '4' : '12'}>
                <TextField
                    id="tsn"
                    label={type === 'unlink' ? "TSN at Removal" : "TSN at Installation"}
                    value={data.tsn || ''}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    variant='outlined'
                    inputProps={{ maxLength: 50 }}
                    onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('tsn', e.target.value) : e.preventDefault() }}
                />
            </Grid>
            <Grid item sm={type == 'add' ? '4' : '12'}>
                <TextField
                    id="csn"
                    label={type === 'unlink' ? "CSN at Removal" : "CSN at Installation"}
                    value={data.csn || ''}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    variant='outlined'
                    inputProps={{ maxLength: 50 }}
                    onChange={(e) => { regexConstants.numberWithDot.test(e.target.value) ? onFieldChange('csn', e.target.value) : e.preventDefault() }}
                />
            </Grid>

        </>
    )
}
